import Button from '@/common/components/Button'
import Modal from '@/common/components/Modal'
import { ModalMessageSimple } from '@/common/components/ModalMessageSimple'
import { FormTransformers } from '@/common/utils/formTransformers'
import { useDeleteGovernmentAllocationDistribution } from '@/features/governmentAllocations/hooks/useDeleteGovernmentAllocationDistribution'
import { useQueryClient } from '@tanstack/react-query'
import { Trash2Icon } from 'lucide-react'
import { useState } from 'react'

interface GovernmentAllocationDistributionDeleteModalProps {
  distributionId?: string
}

export const GovernmentAllocationDistributionDeleteModal = ({
  distributionId,
}: GovernmentAllocationDistributionDeleteModalProps) => {
  const queryClient = useQueryClient()

  const [isOpen, setIsOpen] = useState(false)
  const [messages, setMessages] = useState<string[] | boolean>(false)

  const onSuccess = () => {
    setIsOpen(false)
    queryClient.invalidateQueries({ queryKey: ['companyGovernmentAllocation'] })
    queryClient.invalidateQueries({ queryKey: ['governmentAllocationsDistributions'] })
    queryClient.invalidateQueries({ queryKey: ['governmentAllocationsBranchesToDistribute'] })
    queryClient.invalidateQueries({ queryKey: ['governmentAllocationsAllowedCategoriesAndProducts'] })
  }

  const { mutate: deleteDistribution, isPending: deleteDistributionIsPending } =
    useDeleteGovernmentAllocationDistribution({
      onSuccess,
      onError: (error) => {
        setIsOpen(false)
        FormTransformers.errorsTransformer({ setMessages })(error)
      },
    })

  return (
    <>
      <Modal
        Trigger={
          <Button
            type="button"
            variant="outline-error"
            className="size-10 p-0"
            operationKlassToCheckPermission="Client::Billing::GovernmentAllocationDistributions::Stale"
          >
            <Trash2Icon strokeWidth={1} />
          </Button>
        }
        triggerAsChild
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        title="Você tem certeza?"
        showClose={false}
        useCancellableFooter
        confirmButtonText="Remover divisão de crédito"
        disabled={deleteDistributionIsPending}
        confirmButtonIsLoading={deleteDistributionIsPending}
        onConfirm={() => deleteDistribution(distributionId)}
      />

      <ModalMessageSimple messages={messages} setMessages={setMessages} isError />
    </>
  )
}
